import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import { translate } from '../../../strings/i18n';
import { NoteContainer } from './subcomponents';
const Note = () => {
    return (_jsx(NoteContainer, { children: _jsx(Trans, { i18nKey: "successfulScreen.note", children: translate('successfulScreen.note') }) }));
};
export default Note;
